export default [
    {
      "id": "to-be-present",
      "title": "To Be Present",
      "subtitle": "am, is, are",
      "category": "grammar-exercises",
      "theme": "Business",
      "level": "A1",
      "levelname": "Elementary",
      "time": "",
      "description": "Exercises to practice the verb 'to be' in the present",
      "image": "/Images/1person1.webp"
    },
    {
      "id": "to-be-past",
      "title": "To Be Past",
      "category": "grammar-exercises",
      "subtitle": "was, were",
      "level":"A1",
      "time": "",
      "description": "Exercises to practice the verb 'to be' in the past",
      "image": "/Images/washere.webp"
    },
    {
      "id": "simple-present",
      "title": "Simple Present",
      "category": "grammar-exercises",
      "subtitle": "work, works",
      "level":"A1",
      "time": "",
      "description": "Exercises to practice the simple present tense",
      "image": "/Images/2people1.webp"
    },
    {
      "id": "present-continuous",
      "title": "Present Continuous",
      "category": "grammar-exercises",
      "subtitle": "am, is, are working",
      "level":"A1",
      "time": "",
      "description": "Exercises to practice the present continuous tense",
      "image": "/Images/2people2.webp"
    },
    {
      "id": "some-any",
      "title": "Countable/Uncountable",
      "category": "grammar-exercises",
      "subtitle": "some, any",
      "level":"A1",
      "time": "",
      "description": "Exercises to practice uncountables",
      "image": "/Images/2people3.webp"
    },
    {
      "id": "simpcont",
      "title": "Simple Present vs. Present Continuous",
      "category": "grammar-exercises",
      "subtitle": "I am doing or I do",
      "level":"A2",
      "time": "",
      "description": "Exercises to practice the difference between the present continuous and the simple present tense",
      "image": "/Images/3people1a.webp"
    },
    {
      "id": "past-continuous",
      "title": "Past Continuous",
      "category": "grammar-exercises",
      "subtitle": "was, were doing",
      "level":"A2",
      "time": "",
      "description": "Exercises to practice the past continuous tense",
      "image": "/Images/4people1a.webp"
    },
    {
      "id": "simple-past",
      "title": "Simple Past",
      "category": "grammar-exercises",
      "subtitle": "went, lived",
      "level":"A2",
      "time": "",
      "description": "Exercises to practice the simple past tense",
      "image": "/Images/4people2.webp"
    },
    {
      "id": "future",
      "title": "Future",
      "category": "grammar-exercises",
      "subtitle": "will do, going to do",
      "level":"A2",
      "time": "",
      "description": "Exercises to practice the future tense",
      "image": "/Images/future1.webp"
    },
    {
      "id": "present-perfect",
      "title": "Present Perfect",
      "category": "grammar-exercises",
      "subtitle": "have/has done",
      "level":"B1",
      "time": "",
      "description": "Exercises to practice the present perfect tense",
      "image": "/Images/skydive.webp "
    },
    {
      "id": "perfect-past",
      "title": "Present Perfect vs Past Simple",
      "category": "grammar-exercises",
      "subtitle": "have done or did",
      "level":"B1",
      "time": "",
      "description": "Exercises to practice the difference between the present perfect and the simple past tense",
      "image": "/Images/pastperf1.webp"
    },
    {
      "id": "first-conditional",
      "title": "First Conditional",
      "category": "grammar-exercises",
      "subtitle": "If I do, I will do",

      "level":"B2",

      

      "time": "",
      "description": "Exercises to practice the first conditional",
      "image": "/Images/firstcond1.webp"
    },
    {
      "id": "first-cond-prod",
      "title": "First Conditional (Prompt)",
      "category": "grammar-exercises",
      "subtitle": "If I do, I will do",
      "level":"B1",
      "time": "",
      "description": "Exercises to practice the first conditional with a prompt",
      "image": "/Images/firstcondprod1.webp"
    },
    {
      "id": "second-conditional",
      "title": "Second Conditional",
      "category": "grammar-exercises",
      "subtitle": "If I did, I would do",
      "level":"B2",
      "time": "",
      "description": "Exercises to practice the second conditional",
      "image": "/Images/secondcond1.webp"
    },
    {
      "id": "third-conditional",
      "title": "Third Conditional",
      "category": "grammar-exercises",
      "subtitle": "If I had done, I would have done",
      "level":"B2",
      "time": "",
      "description": "Learn about pet ownership and practice 'so' and 'enough'.",
      "image": "/Images/thirdcond1.webp"
    },
    {
      "id": "mixed-cond-prod",
      "title": "Mixed Conditionals (Prompt)",
      "category": "grammar-exercises",
      "subtitle": "If I had done, I would be now",
      "level":"B2",
      "time": "",
      "description": "Describe people using relative clauses.",
      "image": "/Images/mixedcond1.webp"
    },
    {
      "id": "indirect-speech",
      "title": "Indirect Speech",
      "category": "grammar-exercises",
      "subtitle": "Do you know if",
      "level":"B2",
      "time": "",
      "description": "Asking without asking directly.",
      "image": "/Images/reported1.webp"
    },
    {
      "id": "passive",
      "title": "Passive",
      "category": "grammar-exercises",
      "subtitle": "is made, was made",
      "level":"B2",
      "time": "",
      "description": "Learn about the passive voice and its uses.",
      "image": "/Images/passive1.webp"
    },
    {
      "id": "passivebeing",
      "title": "Passive - being",
      "category": "grammar-exercises",
      "subtitle": "is being made, was being made",
      "level":"B2",
      "time": "",
      "description": "Learn about the passive voice with being.",
      "image": "/Images/Passivebeing1.webp"
    },
    {
      "id": "must-have-to",
      "title": "Must / Have to / Need to / Should",
      "category": "grammar-exercises",
      "subtitle": "must, have to, need to, should, mustn't, don't have to",
      "level":"B1",
      "time": "",
      "description": "Express obligation, necessity, prohibition, and advice with modal and semi-modal verbs.",
      "image": "/Images/must-have-to.webp"
    },
    {
      "id": "modals-deduction",
      "title": "Modals of Deduction",
      "category": "grammar-exercises",
      "subtitle": "must, might, can't",
      "level":"B2",
      "time": "",
      "description": "Learn how to use modals of deduction.",
      "image": "/Images/deduction2.webp"
    },
    {
      "id": "sense-verbs",
      "title": "Sense Verbs",
      "category": "grammar-exercises",
      "subtitle": "look, sound, taste, smell, feel",
      "level":"B2",
      "time": "",
      "description": "Learn how to use sense verbs.",
      "image": "/Images/sense1.webp"
    },
    {
      "id": "ed-ing",
      "title": "Ed or Ing",
      "category": "grammar-exercises",
      "subtitle": "bored, boring",
      "level":"B2",
      "time": "",
      "description": "Learn the difference bewtween bored and boring and other similar word pairs.",
      "image": "/Images/eding1.webp"
    },
    {
      "id": "reported-speech",
      "title": "Reported Speech",
      "category": "grammar-exercises",
      "subtitle": "he said that",
      "level":"B2",
      "time": "",
      "description": "Saying what other people said.",
      "image": "/Images/reportedspeech1.webp"
    },
    {
      "id": "gerunds",
      "title": "Gerunds",
      "category": "grammar-exercises",
      "subtitle": "like doing",
      "level":"B2",
      "time": "",
      "description": "Learn about gerunds and their uses.",
      "image": "/Images/gerunds1.webp"
    },
    {
        "id": "infinitives",
        "title": "Infinitives",
      "category": "grammar-exercises",
      "subtitle": "like to do",
      "level": "B2",
        "time": "",
        "description": "Learn persuasive techniques while practicing different word forms.",
        "image": "/Images/infinitives1.webp"
      },
      {
        "id": "unless",
        "title": "Unless",
      "category": "grammar-exercises",
      "subtitle": "I won't do it unless",

      "level": "B2",

        "time": "",
        "description": "Discuss sports experiences while practicing the present perfect tense.",
        "image": "/Images/unless1.webp"
      },
      {
        "id": "adjadv",
        "title": "Adjectives and Adverbs",
      "category": "grammar-exercises",
      "subtitle": "extremely, very, really important",
      "level": "B2",
        "time": "",
        "description": "Explore extreme weather events while using mixed conditionals.",
        "image": "/Images/adverbadjective1.webp"
      },
      {
        "id": "usedto",
        "title": "Used to",
      "category": "grammar-exercises",
      "subtitle": "used to, be used to, get used to",
      "level": "B2",
        "time": "",
        "description": "Talk about getting or being used to something.",
        "image": "/Images/usedto.webp"
      },
      {
        "id": "pasthabits",
        "title": "Past Habits",
      "category": "grammar-exercises",
      "subtitle": "used to, would",
      "level": "B2",
        "time": "",
        "description": "Talk about past educational experiences and express wishes and regrets.",
        "image": "/Images/habits1.webp"
      },
      {
        "id": "wish",
        "title": "Wishes and Regrets",
      "category": "grammar-exercises",
      "subtitle": "I wish I was, I wish I had done",

      

      "level": "C1",

        "time": "",
        "description": "A lesson to assess students' understanding of various tenses.",
        "image": "/Images/wish1.webp"
      },
      {
        "id": "comparison",
        "title": "Comparison",
      "category": "grammar-exercises",
      "subtitle": "bigger, more interesting",

      "level": "B2",

      

        "time": "",
        "description": "Discuss the air traffic industry and aviation terminology.",
        "image": "/Images/comparison1.webp"
      },
      {
        "id": "soenough",
        "title": "So and Enough",
      "category": "grammar-exercises",
      "subtitle": "so big, big enough",
      "level": "B2",
        "time": "",
        "description": "Discuss the air traffic industry and aviation terminology.",
        "image": "/Images/enough1.webp"
      },
      {
        "id": "relativeclauses",
        "title": "Relative Clauses",
      "category": "grammar-exercises",
      "subtitle": "who is, which is",
      "level": "B2",
        "time": "",
        "description": "Discuss the air traffic industry and aviation terminology.",
        "image": "/Images/office-space-michael-bolton.gif"
      },
      {
        "id": "causeeffect",
        "title": "Cause and Effect",
      "category": "grammar-exercises",
      "subtitle": "because, so, in order to",
      "level": "B2",
        "time": "",
        "description": "Discuss the air traffic industry and aviation terminology.",
        "image": "/Images/causeandeffect1.webp"
      },
      {
        "id": "word-forms",
        "title": "Word Forms",
      "category": "grammar-exercises",
      "subtitle": "decided, decision, decisive, decisively",
      "level": "B2",
        "time": "",
        "description": "Differnt forms of the same word.",
        "image": "/Images/wordforms1.webp"
      },
      {
        "id": "collocations",
        "title": "Collocations",
      "category": "grammar-exercises",
      "subtitle": "highly recommended",

      "level": "B2",

      
        "time": "",
        "description": "Words that always go together.",
        "image": "/Images/collocations1.webp"
      },
      {
        "id": "linking-words",
        "title": "Linking Words",
      "category": "grammar-exercises",
      "subtitle": "even though, in addition to",

      "level": "B2",

      

        "time": "",
        "description": "Words that join ideas.",
        "image": "/Images/linkingwords1.webp"
      },
      {
        "id": "dependent-prepositions",
        "title": "Dependent Prepositions",
      "category": "grammar-exercises",
      "subtitle": "angry at, interested in",
      "level": "B2",
        "time": "",
        "description": "Prepositions that always go with certain verbs.",
        "image": "/Images/dependentpreps1.webp"
      },
      {
          "id": "reading1",
          "title": "Parents at a Football Match",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "A2",
          "time": "",
          "description": "A dialogue of parents talking at a football match.",
        },
        {
          "id": "reading2",
          "title": "Discussing Yesterday's Activities",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "A2",
          "time": "",
          "description": "Another reading for comprehension practice.",
        },
        {
          "id": "reading3",
          "title": "Talking About Your Children",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "A2",
          "time": "",
          "description": "A conversation focused on discussing children and parenting.",
        },
        {
          "id": "reading4",
          "title": "A Meeting with a Boss",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "A2",
          "time": "",
          "description": "A reading about an employee meeting with their boss.",
        },
        {
          "id": "reading5",
          "title": "A Meeting with a Distributor",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "A2",
          "time": "",
          "description": "A business meeting between a company and a distributor.",
        },
        {
          "id": "reading6",
          "title": "Following Up on an Order",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B1",
          "time": "",
          "description": "A conversation about checking the status of a recent order.",
        },
        {
          "id": "reading7",
          "title": "Quarterly Sales Review",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B1",
          "time": "",
          "description": "A business review discussing sales figures from the last quarter.",
        },
        {
          "id": "reading8",
          "title": "Caffeine: The Workplace Drug of Choice",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "An article exploring caffeine consumption and its role in office culture.",
        },
        {
          "id": "reading9",
          "title": "Plans Are Stupid",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "A reading that challenges the value of detailed plans in fast-paced work environments.",
        },
        {
          "id": "reading10",
          "title": "Resolutions",
      "category": "reading-exercises",
      "subtitle": "am, is, are",
      "level": "B2",
          "time": "",
          "description": "A discussion on personal and professional New Year’s resolutions.",
        },
        {
          "id": "reading11",
          "title": "Pets",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "A text exploring the role of pets in people's lives and work-from-home culture.",
        },
        {
          "id": "reading12",
          "title": "Breaking Bad Habits",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "Strategies and challenges related to overcoming workplace and personal habits.",
        },
        {
          "id": "reading13",
          "title": "Chat Productivity",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "An article discussing how workplace chat tools impact productivity.",
        },
        {
          "id": "reading14",
          "title": "App Fatigue",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "Exploring the downsides of using too many productivity and communication apps.",
        },
        {
          "id": "reading15",
          "title": "Self Service Society",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "B2",
          "time": "",
          "description": "A reading about how automation and self-service are changing consumer behavior.",
        },
        {
          "id": "reading16",
          "title": "Self Service Checkout Reddit",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A Reddit discussion analyzing the pros and cons of self-service checkouts.",
        },
        {
          "id": "reading17",
          "title": "Types of People in Tech",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "An exploration of common personality types found in the tech industry.",
        },
        {
          "id": "reading18",
          "title": "Types of Developers",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A lighthearted yet insightful look at different developer archetypes.",
        },
        {
          "id": "reading19",
          "title": "Planned Obsolescence and the Quality of Goods",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A critical examination of how products are intentionally designed to have a limited lifespan.",
        },
        {
          "id": "reading20",
          "title": "Too Many Choices: A Problem That Can Paralyze",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A reading on how excessive choices can lead to stress and indecision.",
        },
        {
          "id": "reading21",
          "title": "Are Dogs Smarter Than Cats? Science Has an Answer",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A scientific look at the intelligence of dogs vs. cats.",
        },
        {
          "id": "reading22",
          "title": "Recommended Steps per Day by Age",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A health-focused article breaking down ideal daily step counts across age groups.",
        },
        {
          "id": "reading23",
          "title": "Neighbor Issues",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "Common problems people face with their neighbors and possible solutions.",
        },
        {
          "id": "reading24",
          "title": "Utensils Around the World",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "An article on cultural differences in eating utensils and traditions.",
        },
        {
          "id": "reading25",
          "title": "Stereotypes About Tech Workers",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A critical look at the common stereotypes surrounding tech professionals.",
        },
        {
          "id": "reading26",
          "title": "Neighbor Conflicts and Etiquette",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "How to handle and avoid conflicts with neighbors through etiquette and communication.",
        },
        {
          "id": "reading27",
          "title": "Plane Crashes: Perception vs. Reality",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A comparison between public perception and actual statistics about air travel safety.",
        },
        {
          "id": "reading28",
          "title": "Sports Hate",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "A discussion about rivalries and why some fans love to hate certain teams.",
        },
        {
          "id": "reading29",
          "title": "Extreme Weather Experiences",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "Personal stories and reflections on living through extreme weather events.",
        },
        {
          "id": "reading30",
          "title": "Education",
      "category": "reading-exercises",
      "subtitle": "",
      "level": "C1",
          "time": "",
          "description": "An analytical look at global education systems and training in the workplace.",
        },
        {
          "id": "reading31",
          "title": "Changing Food Culture",
          "category": "reading-exercises",
          "subtitle": "",
          "level": "C1",
          "time": "",
          "description": "A reading on how modern life and globalization are transforming eating habits.",
        },
        {
        "id": "parents-at-a-football-match",
        "title": "Parents at a Football Match",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "A2",
        "time": "",
        "description": "A dialogue of parents talking at a football match."
      },
      {
        "id": "discussing-yesterdays-activities",
        "title": "Discussing Yesterday's Activities",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "A2",
        "time": "",
        "description": "Another reading for comprehension practice."
      },
      {
        "id": "talking-about-your-children",
        "title": "Talking About Your Children",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "A2",
        "time": "",
        "description": "A conversation focused on discussing children and parenting."
      },
      {
        "id": "a-meeting-with-a-boss",
        "title": "A Meeting with a Boss",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "A2",
        "time": "",
        "description": "A reading about an employee meeting with their boss."
      },
      {
        "id": "a-meeting-with-a-distributor",
        "title": "A Meeting with a Distributor",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "A2",
        "time": "",
        "description": "A business meeting between a company and a distributor."
      },
      {
        "id": "following-up-on-an-order",
        "title": "Following Up on an Order",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B1",
        "time": "",
        "description": "A conversation about checking the status of a recent order."
      },
      {
        "id": "quarterly-sales-review",
        "title": "Quarterly Sales Review",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B1",
        "time": "",
        "description": "A business review discussing sales figures from the last quarter."
      },
      {
        "id": "caffeine-the-workplace-drug-of-choice",
        "title": "Caffeine: The Workplace Drug of Choice",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "An article exploring caffeine consumption and its role in office culture."
      },
      {
        "id": "plans-are-stupid",
        "title": "Plans Are Stupid",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "A reading that challenges the value of detailed plans in fast-paced work environments."
      },
      {
        "id": "resolutions",
        "title": "Resolutions",
        "category": "reading-exercises",
        "subtitle": "am, is, are",
        "level": "B2",
        "time": "",
        "description": "A discussion on personal and professional New Year’s resolutions."
      },
      {
        "id": "pets",
        "title": "Pets",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "A text exploring the role of pets in people's lives and work-from-home culture."
      },
      {
        "id": "breaking-bad-habits",
        "title": "Breaking Bad Habits",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "Strategies and challenges related to overcoming workplace and personal habits."
      },
      {
        "id": "chat-productivity",
        "title": "Chat Productivity",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "An article discussing how workplace chat tools impact productivity."
      },
      {
        "id": "app-fatigue",
        "title": "App Fatigue",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "Exploring the downsides of using too many productivity and communication apps."
      },
      {
        "id": "self-service-society",
        "title": "Self Service Society",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "A reading about how automation and self-service are changing consumer behavior."
      },
      {
        "id": "self-service-checkout",
        "title": "Self Service Checkout Reddit",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A Reddit discussion analyzing the pros and cons of self-service checkouts."
      },
      {
        "id": "tech-people",
        "title": "Types of People in Tech",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "An exploration of common personality types found in the tech industry."
      },
      {
        "id": "types-of-developers",
        "title": "Types of Developers",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A lighthearted yet insightful look at different developer archetypes."
      },
      {
        "id": "planned-obsolescence",
        "title": "Planned Obsolescence and the Quality of Goods",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A critical examination of how products are intentionally designed to have a limited lifespan."
      },
      {
        "id": "too-many-choices",
        "title": "Too Many Choices: A Problem That Can Paralyze",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A reading on how excessive choices can lead to stress and indecision."
      },
      {
        "id": "dogs-cats-intelligence",
        "title": "Are Dogs Smarter Than Cats? Science Has an Answer",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A scientific look at the intelligence of dogs vs. cats."
      },
      {
        "id": "steps-per-day",
        "title": "Recommended Steps per Day by Age",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A health-focused article breaking down ideal daily step counts across age groups."
      },
      {
        "id": "neighbor-issues",
        "title": "Neighbor Issues",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "Common problems people face with their neighbors and possible solutions."
      },
      {
        "id": "utensils-around-the-world",
        "title": "Utensils Around the World",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "An article on cultural differences in eating utensils and traditions."
      },
      {
        "id": "stereotypes-about-tech-workers",
        "title": "Stereotypes About Tech Workers",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A critical look at the common stereotypes surrounding tech professionals."
      },
      {
        "id": "neighbor-conflicts-and-etiquette",
        "title": "Neighbor Conflicts and Etiquette",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "How to handle and avoid conflicts with neighbors through etiquette and communication."
      },
      {
        "id": "plane-crashes-perception-reality",
        "title": "Plane Crashes: Perception vs. Reality",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A comparison between public perception and actual statistics about air travel safety."
      },
      {
        "id": "sports-hate",
        "title": "Sports Hate",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A discussion about rivalries and why some fans love to hate certain teams."
      },
      {
        "id": "extreme-weather-experiences",
        "title": "Extreme Weather Experiences",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "Personal stories and reflections on living through extreme weather events."
      },
      {
        "id": "how-tech-employees-learn",
        "title": "How Tech Employees Learn",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "An analytical look at global education systems and training in the workplace."
      },
      {
        "id": "changing-food-culture",
        "title": "Changing Food Culture",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A reading on how modern life and globalization are transforming eating habits."
      },
      {
        "id": "bakery-storefront",
        "title": "Why We Didn't Open a Bakery Storefront",
        "category": "reading-exercises",
        "subtitle": "",
        "level": "C1",
        "time": "",
        "description": "A reading on why a bakery was not a good business investment."
      },

      {
        "id": "vocabulary-quizzes",
        "title": "Quizzes",
        "category": "quizzes",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "Vocabulary quizzes to test your knowledge.",
        "image": "/Images/quiz1.webp"
      },
      {

        "id": "video1",
        "title": "Create Your Own Words",
        "category": "listening-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "A video discussing the need to create your own words.",
        "image": "/Images/createwords1.webp"
      },
      {
        "id": "video2",
        "title": "Animal Communication and AI",
        "category": "listening-exercises",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "A video discussing using AI to talk to animals.",
        "image": "/Images/animalAI.webp"
      },
{
          "id": "create-your-own-words",
          "title": "Create Your Own Words",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A video discussing the need to create and innovate new words in modern language.",
          "image": "/Images/create-your-own-words.webp"
        },
        {
          "id": "spotify-and-the-music-industry",
          "title": "Spotify and the Music Industry",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An exploration of Spotify’s impact on how music is produced, distributed, and consumed.",
          "image": "/Images/spotify-and-the-music-industry.webp"
        },
        {
          "id": "cell-phones-destroying-society",
          "title": "Cell Phones Destroying Society?",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A discussion on whether mobile devices are negatively affecting social interactions and behavior.",
          "image": "/Images/cell-phones-destroying-society.webp"
        },
        {
          "id": "future-of-work",
          "title": "Future of Work",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An analysis of emerging trends, technologies, and challenges shaping tomorrow’s workplace.",
          "image": "/Images/future-of-work.webp"
        },
        {
          "id": "fast-food",
          "title": "Fast Food",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A critical look at the fast-food industry, its health impacts, and cultural influence.",
          "image": "/Images/fast-food.webp"
        },
        {
          "id": "branding",
          "title": "Branding",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An overview of brand-building strategies and how companies create lasting identities.",
          "image": "/Images/branding.webp"
        },
        {
          "id": "caffeine",
          "title": "Caffeine",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A documentary about caffeine’s effects, uses, and the role it plays in daily life.",
          "image": "/Images/caffeine.webp"
        },
        {
          "id": "new-year",
          "title": "New Year",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A reflection on New Year’s traditions and resolutions across different cultures.",
          "image": "/Images/new-year.webp"
        },
        {
          "id": "easy-to-make",
          "title": "Easy to Make",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A cooking tutorial showcasing simple and quick recipes anyone can prepare at home.",
          "image": "/Images/easy-to-make.webp"
        },
        {
          "id": "habits",
          "title": "Habits",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An exploration of how habits form, break, and influence our daily behavior.",
          "image": "/Images/habits1.webp"
        },
        {
          "id": "app-fatigue",
          "title": "App Fatigue",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A discussion on why too many mobile and web applications can lead to user burnout.",
          "image": "/Images/appfatigue.webp"
        },
        {
          "id": "automation",
          "title": "Automation",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An examination of automation’s impact on industries, jobs, and daily life.",
          "image": "/Images/selfcheckout.webp"
        },
        {
          "id": "self-checkout-systems-convenience-or-cumbersome",
          "title": "Self-Checkout Systems: Convenience or Cumbersome?",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A critique of self-checkout technology and its effects on shoppers and retailers.",
          "image": "/Images/self-checkout-systems-convenience-or-cumbersome.webp"
        },
        {
          "id": "automation4",
          "title": "Automation4",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A follow-up deep dive into the latest advancements and concerns surrounding automation.",
          "image": "/Images/automation4.webp"
        },
        {
          "id": "products-worse",
          "title": "Products Worse",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An investigation into declining product quality and consumer frustration.",
          "image": "/Images/products-worse.webp"
        },
        {
          "id": "the-story-of-planned-obsolescence",
          "title": "The Story of Planned Obsolescence",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A historical look at how companies design products to fail and drive repeat purchases.",
          "image": "/Images/the-story-of-planned-obsolescence.webp"
        },
        {
          "id": "barry-the-paradox-of-choice",
          "title": "Barry The Paradox of Choice",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A presentation by Barry exploring how too many options can impede decision-making.",
          "image": "/Images/barry-the-paradox-of-choice.webp"
        },
        {
          "id": "the-paradox-of-choice",
          "title": "The Paradox of Choice",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A broader examination of choice overload in consumer culture and its psychological impacts.",
          "image": "/Images/the-paradox-of-choice.webp"
        },
        {
          "id": "animal-communication-and-ai",
          "title": "Animal Communication and AI",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A look at how artificial intelligence is being used to decipher animal languages.",
          "image": "/Images/animal-communication-and-ai.webp"
        },
        {
          "id": "purina",
          "title": "Purina",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A corporate profile highlighting Purina’s innovations in pet nutrition and workplace culture.",
          "image": "/Images/purina.webp"
        },
        {
          "id": "the-benefits-of-walking",
          "title": "The Benefits of Walking",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An exploration of how walking regularly can improve physical health and mental well-being.",
          "image": "/Images/the-benefits-of-walking.webp"
        },
        {
          "id": "debunking-exercise-myths",
          "title": "Debunking Exercise Myths",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A fact-based discussion challenging common misconceptions about fitness and exercise.",
          "image": "/Images/debunking-exercise-myths.webp"
        },
        {
          "id": "self-driving-car-moral-dilemma",
          "title": "Self-driving car moral dilemma",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An analysis of the ethical decisions self-driving vehicles must make in critical situations.",
          "image": "/Images/self-driving-car-moral-dilemma.webp"
        },
        {
          "id": "tourisms-impact-on-cities",
          "title": "Tourism's Impact on Cities",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A study of how tourism reshapes urban landscapes economically, socially, and environmentally.",
          "image": "/Images/tourisms-impact-on-cities.webp"
        },
        {
          "id": "utensils",
          "title": "Utensils",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A cultural journey examining eating utensils around the world and their historical significance.",
          "image": "/Images/utensils.webp"
        },
        {
          "id": "people",
          "title": "People",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An overview of generational differences and how they shape workplace and social dynamics.",
          "image": "/Images/people.webp"
        },
        {
          "id": "giving-feedback",
          "title": "Giving Feedback",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A guide to delivering constructive feedback effectively in professional environments.",
          "image": "/Images/giving-feedback.webp"
        },
        {
          "id": "the-secret-to-great-feedback",
          "title": "The Secret to Great Feedback",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "Insider tips on how to receive and give feedback that truly fosters growth and improvement.",
          "image": "/Images/the-secret-to-great-feedback.webp"
        },
        {
          "id": "gossip",
          "title": "Gossip",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An investigation of how gossip spreads and its social effects in personal and professional contexts.",
          "image": "/Images/gossip.webp"
        },
        {
          "id": "gossip-positive",
          "title": "Gossip Positive",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An analysis of when and how gossip can serve as a positive social tool in communities.",
          "image": "/Images/gossip-positive.webp"
        },
        {
          "id": "sustainability",
          "title": "Sustainability",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A discussion on sustainable practices and their importance for the environment and economy.",
          "image": "/Images/sustainability.webp"
        },
        {
          "id": "greenwash-today-suffer-tomorrow",
          "title": "Greenwash today, suffer tomorrow",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A critique of deceptive environmental marketing practices and their long-term consequences.",
          "image": "/Images/greenwash-today-suffer-tomorrow.webp"
        },
        {
          "id": "tech-solutions",
          "title": "Tech solutions",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An overview of emerging technology solutions transforming industries and everyday life.",
          "image": "/Images/tech-solutions.webp"
        },
        {
          "id": "medicine",
          "title": "Medicine",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A historical and modern examination of medical breakthroughs and their societal impact.",
          "image": "/Images/medicine.webp"
        },
        {
          "id": "theranos",
          "title": "Theranos",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A deep dive into the rise and fall of Theranos and the lessons learned from its scandal.",
          "image": "/Images/theranos.webp"
        },
        {
          "id": "persuading",
          "title": "Persuading",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A presentation on the psychology of persuasion and effective communication techniques.",
          "image": "/Images/persuading.webp"
        },
        {
          "id": "persuading2",
          "title": "Persuading2",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A continuation of persuasive strategies, focusing on real-world applications and ethics.",
          "image": "/Images/persuading2.webp"
        },
        {
          "id": "why-we-watch-sports",
          "title": "Why We Watch Sports",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An exploration of the social, psychological, and economic reasons behind sports fandom.",
          "image": "/Images/why-we-watch-sports.webp"
        },
        {
          "id": "extreme-weather",
          "title": "Extreme Weather",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A look at extreme weather events and their causes, impacts, and preventive measures.",
          "image": "/Images/extreme-weather.webp"
        },
        {
          "id": "strange-summer",
          "title": "Strange Summer",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "A documentary on unusual summer phenomena and their implications for climate science.",
          "image": "/Images/strange-summer.webp"
        },
        {
          "id": "tetris-weather",
          "title": "Tetris Weather",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An innovative presentation using game mechanics to explain weather patterns and forecasting.",
          "image": "/Images/tetris-weather.webp"
        },
        {
          "id": "ai-school",
          "title": "AI School",
          "category": "videos",
          "subtitle": "",
          "level": "B2",
          "time": "",
          "description": "An educational series on how artificial intelligence is transforming modern education.",
          "image": "/Images/ai-school.webp"
        },

      {
        "id": "b2-adj-flashcards",
        "title": "Flashcards",
        "category": "flashcards",
        "subtitle": "",
        "level": "B2",
        "time": "",
        "description": "Flashcards to practice the essential verbs, nouns and adjectives in English.",
        "image": "/Images/flaschcards1.webp"
      }
  ]
  

